import { Cross } from "components/icons/Cross";
import { LinkIcon } from "components/icons/LinkIcon";
import { useDispatch, useSelector } from "react-redux";
import { deleteCustomLink } from "store/slices/reviewAndBalancePayment";
import { RootState } from "store/store";
import { LocalFileOrInkleDocs } from "types/Models/reviewDocumentAndBalancingPayment";
import { CustomFilePreviewCard } from "./CustomFilePreviewCard";

export const CustomAttachmentPreviewList = () => {
  const dispatch = useDispatch();
  const attachments = useSelector(
    (state: RootState) => state.reviewAndBalancePayment.customAttachment
  );
  const links = useSelector(
    (state: RootState) => state.reviewAndBalancePayment.customLinks
  );

  return (
    <div className="custom-attachment-preview-list t-flex t-gap-3 t-overflow-x-auto t-overflow-y-hidden t-pr-2">
      {attachments.map((attachment: LocalFileOrInkleDocs) => {
        const extension = attachment?.name
          ?.split?.(".")
          ?.pop?.()
          ?.toUpperCase?.();
        let path = "";
        if ("uuid" in attachment) {
          path = attachment.uuid;
        }
        if ("path" in attachment) {
          path = attachment.path;
        }
        return (
          <CustomFilePreviewCard
            key={path}
            name={attachment.name}
            extension={extension!}
            path={path}
          />
        );
      })}
      {links.map((link) => (
        <div
          key={link.url}
          className="t-group t-mt-2 t-py-2 t-px-3 t-flex t-gap-2 t-border t-border-solid t-border-purple-20 t-rounded t-relative"
        >
          <div className="t-flex t-items-center t-justify-center t-h-10 t-w-10 t-text-purple">
            <LinkIcon color="currentColor" />
          </div>
          <div className="t-flex t-flex-col t-justify-between t-w-20">
            <div className="t-text-subtext-sm t-truncate t-w-full">
              {link.name}
            </div>
            <div className="t-text-body-sm t-text-neutral t-truncate t-w-full">
              {link.url}
            </div>
          </div>
          <button
            className="all:unset t-h-5 t-w-5 t-rounded-full t-flex t-items-center t-justify-center t-bg-purple-20 t-absolute -t-top-[8px] -t-right-[8px]"
            onClick={() => dispatch(deleteCustomLink(link.url))}
          >
            <Cross />
          </button>
        </div>
      ))}
    </div>
  );
};
